import { jsx } from "react/jsx-runtime";
import { FilteredFAQ } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const FAQ_BLOCK_NAME = "constellation/faq";
const BlockFaqFiltered = ({
  innerBlocks,
  attrs: {
    categories = [],
    defaultCategory = "All"
  }
}) => {
  const faqBlocks = (innerBlocks ?? []).filter((block) => block.blockName === FAQ_BLOCK_NAME);
  if (!faqBlocks.length) {
    return null;
  }
  return /* @__PURE__ */ jsx(FilteredFAQ, { categories, defaultCategory, children: faqBlocks.map((faqBlock, index) => {
    var _a, _b;
    return /* @__PURE__ */ jsx(FilteredFAQ.Group, { category: (_a = faqBlock.attrs) == null ? void 0 : _a.category, children: generateBlockList({
      blocks: [faqBlock]
    }) }, ((_b = faqBlock.attrs) == null ? void 0 : _b.id) ?? index);
  }) });
};
BlockFaqFiltered.propTypes = {
  attrs: PropTypes.shape({
    categories: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string
    })),
    defaultCategory: PropTypes.string
  }).isRequired,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({
    blockName: PropTypes.string,
    attrs: PropTypes.shape({
      id: PropTypes.string,
      category: PropTypes.string,
      allExpanded: PropTypes.bool,
      collapseOthers: PropTypes.bool
    }),
    innerBlocks: PropTypes.arrayOf(PropTypes.shape({}))
  })).isRequired
};
export {
  BlockFaqFiltered as default
};
